import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { NzTableModule } from 'ng-zorro-antd/table';

import { RouterLink } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzIconModule } from 'ng-zorro-antd/icon';

import { ClarificationQueryRoutingModule } from './clarification-query-routing.module';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { SharedModule } from 'src/app/shared/shared.module';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { ClarificationQueryListService } from './clarification-query-list.service';
import { QueryListComponent } from './query-list/query-list.component';
import { CreateQueryComponent } from './create-query/create-query.component';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NgZorroModule } from 'src/app/ng-zorro.module';
import { ViewQueryComponent } from './view-query/view-query.component';
import { UpdateQueryComponent } from './update-query/update-query.component';
import { PartnerViewQueryComponent } from './partner-view-query/partner-view-query.component';
import { AddAttachmentsComponent } from './add-attachments/add-attachments.component';
import { ViewAttachmentsComponent } from './view-attachments/view-attachments.component';
import { InternalUserViewQueryComponent } from './internal-user-view-query/internal-user-view-query.component';
import { ViewPreviousQueryDetailsComponent } from './view-previous-query-details/view-previous-query-details.component';
import { QueryDetailInfoComponent } from './query-detail-info/query-detail-info.component';
import { RespondedQueryComponent } from './responded-query/responded-query.component';
import { MyQueryListComponent } from './my-query-list/my-query-list.component';
import { DeleteQueryComponent } from './delete-query/delete-query.component';
import { ReopenQueryComponent } from './reopen-query/reopen-query.component';
import { PendingQueryComponent } from './pending-query/pending-query.component';
import { ViewCommentsComponent } from './view-comments/view-comments.component';
import { RecycleQueryComponent } from './recycle-query/recycle-query.component';
import { SuccessComponent } from './success/success.component';



@NgModule({
  declarations: [  
    QueryListComponent, 
    CreateQueryComponent, 
    ViewQueryComponent, 
    UpdateQueryComponent, 
    PartnerViewQueryComponent, 
    AddAttachmentsComponent, 
    ViewAttachmentsComponent, 
    InternalUserViewQueryComponent, 
    ViewPreviousQueryDetailsComponent, 
    QueryDetailInfoComponent, 
    RespondedQueryComponent, 
    MyQueryListComponent, 
    DeleteQueryComponent, 
    ReopenQueryComponent, 
    PendingQueryComponent, ViewCommentsComponent, RecycleQueryComponent, SuccessComponent
  ],
  providers: [
    ClarificationQueryListService    
  ],
  imports: [
    CommonModule,
    SharedModule,
    NzTableModule,
    RouterLink,
    FormsModule,  
    
    ReactiveFormsModule, 
    ClarificationQueryRoutingModule,
    NgZorroModule  
  ],
  exports: [QueryDetailInfoComponent]
})
export class ClarificationQueryModule { }
